import { Box, Typography, Button } from '@mui/material';
import env from '../../../../config/env';

const FallbackComponent = ({ error, resetErrorBoundary }) => {
  const isDev = env.CUSTOM_NODE_ENV === 'development' || import.meta.env?.DEV;

  if (isDev) {
    return (
      <Box p={3}>
        <Typography variant="h6" color="error">
          Error: {error.message}
        </Typography>
        <Box
          component="pre"
          sx={{ whiteSpace: 'pre-wrap', mt: 2, fontSize: '12px' }}
        >
          {error.stack}
        </Box>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      p={3}
      textAlign="center"
    >
      <Typography variant="h4" gutterBottom>
        Oops! Algo salió mal.
      </Typography>
      <Typography variant="body1" color="textSecondary" mb={3}>
        Hemos detectado un problema y estamos trabajando en ello. Por favor,
        intenta de nuevo.
      </Typography>
      <Button variant="contained" color="primary" onClick={resetErrorBoundary}>
        Recargar
      </Button>
    </Box>
  );
};

export default FallbackComponent;
